import {
    faAddressBook, faCalendar, faCalendarDay, faCalendarXmark, faCertificate, faClock,
    faCoins, faFolderPlus, faGlobeAmericas,
    faComments, faFileContract, faFileInvoice, faFileLines,
    faMoneyCheck, faTags, faTasks, faToolbox,
    faUser, faUserClock, faUserGroup, faUserLock, faUserTag, faWallet, faWarehouse,
    faBoxOpen,
    faPhoneSlash,
    faPhoneVolume,
    faFlag,
    faMapLocation,
} from '@fortawesome/free-solid-svg-icons';
import { AppNavPaths } from '../Common';

export const Pages = {
    Estimates: 'Estimates',
    Contracts: 'Contracts',
    DailyJobsView: 'DailyJobsView',
    RosterView: 'RosterView',
    Dispatch: 'Dispatch',
    DispatchPlus: 'DispatchPlus',
    Employees: 'Employees',
    Delegates: 'Delegates',
    Equipment: 'Equipment',
    Jobs: 'Jobs',
    Projects: 'Projects',
    Organizations: 'Organizations',
    Contacts: 'Contacts',
    ContactActivities: 'ContactActivities',
    MyCalendar: 'MyCalendar',
    JobCalendar: 'JobCalendar',
    AddTimesheet: 'AddTimesheet',
    MyTimesheets: 'MyTimesheets',
    TimeTracker: 'TimeTracker',
    TimesheetManagement: 'TimesheetManagement',
    ChargeView: 'ChargeView',
    Billing: 'Billing',
    BillingIssues: 'BillingIssues',
    DispatchIssues: 'DispatchIssues',
    DispatchGroup: 'DispatchGroup',
    BillingCharges: 'BillingCharges',
    BillingChargeCategories: 'BillingChargeCategories',
    InvoiceGeneration: 'InvoiceGeneration',
    Invoices: 'Invoices',
    RentalInvoices: 'RentalInvoices',
    BillingRates: 'BillingRates',
    PayrollCharges: 'PayrollCharges',
    PayrollPayCategories: 'PayrollPayCategories',
    CollectedReporting: 'CollectedReporting',
    ActiveEmployees: 'ActiveEmployees',
    ChargeTypes: 'ChargeTypes',
    ChargeTypeGroups: 'ChargeTypeGroups',
    ContractTemplates: 'ContractTemplates',
    UserGroups: 'UserGroups',
    Groups: 'Groups',
    Roles: 'Roles',
    EquipmentTypes: 'EquipmentTypes',
    EquipmentTags: 'EquipmentTags',
    OperationalCategories: 'OperationalCategories',
    ResourceKits: 'ResourceKits',
    InventoryItems: 'InventoryItems',
    LongTermStatuses: 'LongTermStatuses',
    DailyAttendanceEvents: 'DailyAttendanceEvents',
    JobAssignmentCancellationTypes: 'JobAssignmentCancellationTypes',
    CompanyBillingGroups: 'CompanyBillingGroups',
    PaySchedules: 'PaySchedules',
    CountyGroups: 'CountyGroups',
    JotForms: 'JotForms',
    Certifications: 'Certifications',
    QuickSales: 'QuickSales',
    JobTypes: 'JobTypes',
    CallDispositions: 'CallDispositions',
    SupportTools: 'SupportTools',
};

export const Requirements = {
    NonFlaggingAccess: 'NonFlaggingAccess',
    Contracts: 'Contracts',
    Organizations: 'Organizations',
    Delegates: 'Delegates',
    Equipment: 'Equipment',
    Employees: 'Employees',
    Jobs: 'Jobs',
    Projects: 'Projects',
    Estimates: 'Estimates',
    Contacts: 'Contacts',
    ContactActivites: 'ContactActivities',
    Payroll: 'Payroll',
    Billing: 'Billing',
    Invoicing: 'Invoicing',
    Rentals: 'Rentals',
    ChargeTypeGroups: 'ChargeTypeGroups',
    PrevailingWage: 'PrevailingWage',
    Union: 'Union',
    JotForms: 'JotForms',
    Certifications: 'Certifications',
    LongTermStatuses: 'LongTermStatuses',
    DailyAttendanceEvents: 'DailyAttendanceEvents',
    QuickSales: 'QuickSales',
    NonCombinedInvoices: 'NonCombinedInvoices',
    TimeTracker: 'TimeTracker',
    CallDispositions: 'CallDispositions',
    UnionOrPrevailingWage: 'UnionOrPrevailingWage',
};

export const Sections = [
    {
        title: 'My Work',
        i18nKey: 'nav:myWork',
        requirements: [Requirements.NonFlaggingAccess],
        expanded: true,
        pages: [
            {
                action: 'view',
                entity: 'nonflaggingtimesheet',
                label: 'Add Timesheet',
                i18nKey: 'nav:addTimesheet',
                icon: faUserClock,
                url: AppNavPaths.NonFlaggingTimesheetNew,
                name: Pages.AddTimesheet,
            },
            {
                action: 'view',
                entity: 'calendar',
                label: 'My Calendar',
                i18nKey: 'nav:myCalendar',
                icon: faCalendar,
                url: AppNavPaths.AssignmentCalendar,
                name: Pages.MyCalendar,
            },
            {
                action: 'view',
                entity: 'jobcalendar',
                label: 'Job Calendar',
                i18nKey: 'nav:jobCalendar',
                icon: faCalendar,
                url: AppNavPaths.CalendarJobs,
                name: Pages.JobCalendar,
            },
            {
                action: 'view',
                entity: 'nonflaggingtimesheet',
                label: 'My Timesheets',
                i18nKey: 'nav:myTimesheets',
                icon: faClock,
                url: AppNavPaths.EmployeeTimesheets,
                badge: ({ timesheetNotificationCount }) => timesheetNotificationCount,
                name: Pages.MyTimesheets,
            },
            {
                action: 'view',
                entity: 'nonflaggingtimesheet',
                label: 'Time Tracker',
                i18nKey: 'nav:timeTracker',
                icon: faUserClock,
                url: AppNavPaths.TimeTracker,
                name: Pages.TimeTracker,
                requirements: [Requirements.TimeTracker],
            },
        ],
    },
    {
        title: 'Contracts & Organizations',
        requirements: [Requirements.Contracts, Requirements.Organizations],
        pages: [
            {
                action: 'view',
                entity: 'certification',
                label: 'Certifications',
                icon: faCertificate,
                url: AppNavPaths.Certifications,
                name: Pages.Certifications,
                requirements: [Requirements.Certifications],
            },
            {
                action: 'view',
                entity: 'contract',
                label: 'Contracts',
                icon: faFileContract,
                url: AppNavPaths.Contracts,
                newTitle: 'Add a Contract',
                newUrl: AppNavPaths.ContractNew,
                name: Pages.Contracts,
            },
            {
                action: 'view',
                entity: 'location_contact',
                label: 'Contacts',
                icon: faAddressBook,
                url: AppNavPaths.Contacts,
                requirements: [Requirements.Contacts],
                name: Pages.Contacts,
            },
            {
                action: 'view',
                entity: 'contactactivity',
                label: 'Contact Activities',
                icon: faComments,
                url: AppNavPaths.ContactActivities,
                requirements: [Requirements.ContactActivites],
                name: Pages.ContactActivities,
            },
            {
                action: 'view',
                entity: 'contract',
                label: 'Estimates',
                icon: faFileContract,
                url: AppNavPaths.Estimates,
                requirements: [Requirements.Estimates],
                name: Pages.Estimates,
            },
            {
                action: 'view',
                entity: 'location',
                label: 'Organizations',
                icon: faWarehouse,
                url: AppNavPaths.Organizations,
                newTitle: 'Add Organization',
                newUrl: AppNavPaths.OrganizationNew,
                name: Pages.Organizations,
            },
            {
                action: 'view',
                entity: 'contract_template',
                label: 'Templates',
                icon: faFileContract,
                url: AppNavPaths.ContractTemplateIndex,
                newTitle: 'Add a Contract Template',
                newUrl: AppNavPaths.ContractTemplateNew,
                name: Pages.ContractTemplates,
            },
        ],
    },
    {
        title: 'Resources',
        requirements: [Requirements.Employees, Requirements.Equipment],
        pages: [
            {
                action: 'view',
                entity: 'chargetype',
                label: 'Charge Types',
                icon: faCoins,
                url: AppNavPaths.ChargeTypes,
                name: Pages.ChargeTypes,
                newTitle: 'Add a Charge Type',
                newUrl: AppNavPaths.ChargeTypeNew,
            },
            {
                action: 'view',
                entity: 'chargetype',
                label: 'Charge Type Groups',
                icon: faCoins,
                url: AppNavPaths.ChargeTypeGroups,
                name: Pages.ChargeTypeGroups,
                newTitle: 'Add a Charge Type Group',
                newUrl: AppNavPaths.ChargeTypeGroupNew,
                requirements: [Requirements.ChargeTypeGroups],
            },
            {
                action: 'view',
                entity: 'dailyattendanceevent',
                label: 'Daily Attendance Events',
                icon: faUserTag,
                url: AppNavPaths.DailyAttendanceEvents,
                name: Pages.DailyAttendanceEvents,
                requirements: [Requirements.DailyAttendanceEvents],
            },
            {
                action: 'view',
                entity: 'employee',
                label: 'Delegates',
                icon: faUser,
                url: AppNavPaths.Delegates,
                requirements: [Requirements.Delegates],
                name: Pages.Delegates,
            },
            {
                action: 'view',
                entity: 'employee',
                label: 'Employees',
                icon: faUser,
                url: AppNavPaths.Employees,
                newTitle: 'Add a new employee',
                newUrl: AppNavPaths.EmployeeNew,
                name: Pages.Employees,
            },
            {
                action: 'view',
                entity: 'equipment',
                label: 'Equipment',
                icon: faToolbox,
                url: AppNavPaths.Equipment,
                newTitle: 'Add Equipment',
                newUrl: `${AppNavPaths.Equipment}?new=true`,
                name: Pages.Equipment,
            },
            {
                action: 'view',
                entity: 'equipment_tag',
                label: 'Equipment Tags',
                icon: faTags,
                url: AppNavPaths.EquipmentTags,
                newTitle: 'Add Equipment Tag',
                newUrl: AppNavPaths.EquipmentTagNew,
                name: Pages.EquipmentTags,
            },
            {
                action: 'view',
                entity: 'operational_category',
                label: 'Operational Categories',
                icon: faClock,
                url: AppNavPaths.OperationalCategories,
                newTitle: 'Add Operational Category',
                newUrl: AppNavPaths.OperationalCategoryNew,
                name: Pages.OperationalCategories,
            },
            {
                action: 'view',
                entity: 'equipmenttype',
                label: 'Equipment Types',
                icon: faToolbox,
                url: AppNavPaths.EquipmentTypes,
                name: Pages.EquipmentTypes,
            },
            {
                action: 'view',
                entity: 'jobType',
                label: 'Job Types',
                icon: faToolbox,
                url: AppNavPaths.JobTypes,
                name: Pages.JobTypes,
            },
            {
                action: 'view',
                entity: 'longtermstatus',
                label: 'Long Term Statuses',
                icon: faCalendarXmark,
                url: AppNavPaths.LongTermStatuses,
                name: Pages.LongTermStatuses,
                requirements: [Requirements.LongTermStatuses],
            },
            {
                action: 'view',
                entity: 'resourceKit',
                label: 'Resource Kits',
                icon: faBoxOpen,
                url: AppNavPaths.ResourceKits,
                newTitle: 'Add Resource Kit',
                newUrl: AppNavPaths.ResourceKitNew,
                name: Pages.ResourceKits,
            },
            {
                action: 'view',
                entity: 'employee_daily_roster',
                label: 'Roster View',
                icon: faCalendarDay,
                url: AppNavPaths.EmployeeDailyRoster,
                name: Pages.RosterView,
            },
            {
                action: 'view',
                entity: 'jobassignmentcancellationtype',
                label: 'Job Assignment Cancellation Types',
                icon: faPhoneSlash,
                url: AppNavPaths.JobAssignmentCancellationTypes,
                name: Pages.JobAssignmentCancellationTypes,
            },
            {
                action: 'view',
                entity: 'call_disposition',
                label: 'Call Dispositions',
                icon: faPhoneVolume,
                url: AppNavPaths.CallDispositions,
                name: Pages.CallDispositions,
            },
        ],
    },
    {
        title: 'Jobs',
        requirements: [Requirements.Jobs],
        pages: [
            {
                action: 'view',
                entity: 'dispatch_review',
                label: 'Charge View',
                icon: faTasks,
                url: AppNavPaths.ChargeView,
                name: Pages.ChargeView,
            },
            {
                action: 'view',
                entity: 'job_daily_view',
                label: 'Daily Jobs View',
                icon: faCalendarDay,
                url: AppNavPaths.JobView,
                name: Pages.DailyJobsView,
            },
            {
                action: 'view',
                entity: 'dispatch',
                label: 'Dispatch',
                icon: faUser,
                url: AppNavPaths.Dispatch,
                name: Pages.Dispatch,
            },
            {
                action: 'view',
                entity: 'dispatch_issues',
                label: 'Dispatch Issues',
                icon: faFlag,
                url: AppNavPaths.DispatchIssues,
                name: Pages.DispatchIssues,
            },
            {
                action: 'view',
                entity: 'dispatch_group',
                label: 'Dispatch Groups',
                icon: faMapLocation,
                url: AppNavPaths.DispatchGroups,
                name: Pages.DispatchGroup,
            },
            {
                action: 'view',
                entity: 'dispatch_plus',
                label: 'Dispatch Plus',
                icon: faTasks,
                url: AppNavPaths.DispatchPlusDispatch,
                name: Pages.DispatchPlus,
            },
            {
                action: 'view',
                entity: 'job',
                label: 'Jobs',
                icon: faFileContract,
                url: AppNavPaths.Jobs,
                name: Pages.Jobs,
            },
            {
                action: 'view',
                entity: 'jot_form',
                label: 'Jot Forms',
                icon: faFolderPlus,
                url: AppNavPaths.JotForms,
                name: Pages.JotForms,
                requirements: [Requirements.JotForms],
            },
            {
                action: 'view',
                entity: 'job',
                label: 'Projects',
                icon: faFileLines,
                url: AppNavPaths.Projects,
                requirements: [Requirements.Projects],
                name: Pages.Projects,
            },
            {
                action: 'view',
                entity: 'dispatch_review',
                label: 'Timesheet Management',
                icon: faTasks,
                url: AppNavPaths.TimesheetManagement,
                name: Pages.TimesheetManagement,
            },
        ],
    },
    {
        title: 'Billing',
        requirements: [Requirements.Billing],
        pages: [
            {
                action: 'view',
                entity: 'billing',
                label: 'Billing',
                icon: faFileInvoice,
                url: AppNavPaths.Billing,
                name: Pages.Billing,
            },
            {
                action: 'view',
                entity: 'billing',
                label: 'Billing Rates',
                icon: faFileInvoice,
                url: AppNavPaths.BillingRate,
                requirements: [Requirements.Invoicing],
                name: Pages.BillingRates,
            },
            {
                action: 'view',
                entity: 'billing',
                label: 'Billing: Charges',
                icon: faFileInvoice,
                url: AppNavPaths.BillingCharge,
                requirements: [Requirements.Invoicing],
                name: Pages.BillingCharges,
            },
            {
                action: 'view',
                entity: 'billing',
                label: 'Billing: Charge Cats',
                icon: faFileInvoice,
                url: AppNavPaths.BillingChargeCategory,
                requirements: [Requirements.Invoicing],
                name: Pages.BillingChargeCategories,
            },
            {
                action: 'view',
                entity: 'billing_issues',
                label: 'Billing: Issues',
                icon: faComments,
                url: AppNavPaths.BillingIssues,
                requirements: [Requirements.Invoicing],
                name: Pages.BillingIssues,
            },
            {
                action: 'view',
                entity: 'quickBooksInventoryItem',
                label: 'Inventory Items',
                icon: faWallet,
                url: AppNavPaths.QuickBooksInventoryItems,
                requirements: [Requirements.Invoicing],
                newTitle: 'Add Inventory Item',
                newUrl: AppNavPaths.QuickBooksInventoryItemNew,
                name: Pages.InventoryItems,
            },
            {
                action: 'view',
                entity: 'invoice',
                label: 'Invoice Gen',
                icon: faFileInvoice,
                url: AppNavPaths.InvoiceGeneration,
                requirements: [Requirements.Invoicing, Requirements.NonCombinedInvoices],
                name: Pages.InvoiceGeneration,
            },
            {
                action: 'view',
                entity: 'invoice',
                label: 'Invoices',
                icon: faFileInvoice,
                url: AppNavPaths.Invoice,
                requirements: [Requirements.Invoicing],
                name: Pages.Invoices,
            },
            {
                action: 'view',
                entity: 'rental_invoice',
                label: 'Rental Invoices',
                icon: faFileInvoice,
                url: AppNavPaths.RentalInvoice,
                requirements: [Requirements.Rentals],
                name: Pages.RentalInvoices,
            },
            {
                action: 'view',
                entity: 'quick_sale',
                label: 'Quick Sales',
                icon: faFileInvoice,
                url: AppNavPaths.QuickSales,
                requirements: [Requirements.QuickSales],
                name: Pages.QuickSales,
            },
        ],
    },
    {
        title: 'Payroll',
        requirements: [Requirements.Payroll],
        pages: [
            {
                action: 'view',
                entity: 'county_group',
                label: 'County Groups',
                icon: faGlobeAmericas,
                url: AppNavPaths.USCountyGroups,
                name: Pages.CountyGroups,
                newTitle: 'Add a County Group',
                newUrl: AppNavPaths.USCountyGroupNew,
                requirements: [Requirements.UnionOrPrevailingWage],
            },
            {
                action: 'view',
                entity: 'payroll',
                label: 'Payroll: Charges',
                icon: faMoneyCheck,
                url: AppNavPaths.PayrollManagement,
                name: Pages.PayrollCharges,
            },
            {
                action: 'view',
                entity: 'payroll',
                label: 'Payroll: Pay Cats',
                icon: faMoneyCheck,
                url: AppNavPaths.Payroll,
                name: Pages.PayrollPayCategories,
            },
            {
                action: 'view',
                entity: 'payroll',
                label: 'Pay Schedules',
                icon: faGlobeAmericas,
                url: AppNavPaths.PaySchedule,
                name: Pages.PaySchedules,
                requirements: [Requirements.PrevailingWage],
            },
            {
                action: 'view',
                entity: 'user_group',
                label: 'Resource Groups',
                icon: faUserGroup,
                url: AppNavPaths.UserGroups,
                name: Pages.UserGroups,
                newTitle: 'Add a Resource Group',
                newUrl: AppNavPaths.UserGroupNew,
            },
            {
                action: 'view',
                entity: 'role',
                label: 'Roles',
                icon: faUserLock,
                url: AppNavPaths.Roles,
                name: Pages.Roles,
                newTitle: 'Add a Role',
                newUrl: AppNavPaths.RoleNew,
            },
            {
                action: 'view',
                entity: 'group',
                label: 'Role Groups',
                icon: faUserGroup,
                url: AppNavPaths.Groups,
                name: Pages.Groups,
                newTitle: 'Add a Role Group',
                newUrl: AppNavPaths.GroupNew,
            },
        ],
    },
];

export const FlattenedSections = Sections.map((section) => section.pages).flat();